import { EvrideoDialogService } from "./../../infrastructure/common/evrideo-dialog-service.service";
import { SettingsButtonComponent } from "./settings-button/settings-button.component";
import { HeadPhoneComponent } from "./head-phone/head-phone.component";
import { WebRTCSrcDirective } from "./webRTC/webrtc-src.directive";
import { LiveBroadcastLinkComponent } from "./live-broadcast-link/live-broadcast-link.component";
import { IChannelBroadcastModeChecker } from "../../domain/broadcasts/i-channel-broadcast-mode-checker";
import { ChannelBroadcastModeChecker } from "../../infrastructure/broadcasts/channel-broadcast-mode-checker";
import { VolumeIconComponent } from "./volume-icon/volume-icon.component";
import { FullScreenIconComponent } from "./full-screen-icon/full-screen-icon.component";
import { GearIconComponent } from "./gear-icon/gear-icon.component";
import { NgModule } from "@angular/core";
import { InlineSVGModule } from "ng-inline-svg-2";
import { CommonModule } from "@angular/common";
import { ImageComponent } from "./image/image.component";
import { PreviewButtonComponent } from "./preview-button/preview-button.component";
import { DateTimePickerComponent } from "./date-time-picker/date-time-picker.component";
import { SeparateTimePickerComponent } from "./separate-time-picker/separate-time-picker.component";
import { TimeSliceComponent } from "./separate-time-picker/time-slice/time-slice.component";
import { DatepickerModule } from "../datePicker/datepicker.module";
import { CopyClipboardDirective } from "./clipboard/copy-clipboard.directive";
import { CopyButtonComponent } from "./copy-button/copy-button.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { XButtonComponent } from "./x-button/x-button.component";
import { TimeEditorComponent } from "./time-editor/time-editor.component";
import { HoverButtonComponent } from "./hover-button/hover-button.component";
import { TimeSliderComponent } from "./time-slider/time-slider.component";
import { DurationPipe } from "../../pipes/duration.pipe";
import { NumberInputComponent } from "./numberInput/number-input.component";
import { RemoveButtonComponent } from "./remove-button/remove-button.component";
import { DropdownComponent } from "./_dropdown/dropdown.component";
import { DropdownItemComponent } from "./_dropdown/dropdown-item.component";
import { InputComponent } from "./input/input.component";
import { SimpleTextInputComponent } from "./simple-text-input/simple-text-input.component";
import { CloseButtonComponent } from "./close-btn/close-btn";
import { VideoContainerComponent } from "../videoContainer/videoContainer.component";
import { TimecodePipe } from "../../pipes/timecode.pipe";
import { HlsSrc } from "./hlsSrc/hls-src";
import { RadioCollectionComponent } from "./radioCollection/radioCollection.component";
import { FormsModule } from "@angular/forms";
import { HumanizePipe } from "../../pipes/humanize.pipe";
import { ColorPickerComponent } from "./colorPicker/color-picker.component";
import { ColorPickerModule } from "ngx-color-picker";
import { iDropdownComponent } from "./iDropdown/iDropdown.component";
import { CalendarHeaderDropdownComponent } from "../calendar/calendar-header/calendar-header-dropdown/calendar-header-dropdown.component";
import { RectangleFComponent } from "./rectangle-f/rectangle-f.component";
import { LayerInputComponent } from "./graphics-layers/layer-input.component";
import { RemoveCommaPipe } from "../../pipes/remove-comma.pipe";
import { CalendarIconComponent } from "./calendar-icon/calendar-icon.component";
import { LinkComponent } from "./link/link.component";
import { RouterModule } from "@angular/router";
import { ButtonComponent } from "./button/button.component";
import { DateinputComponent } from "./dateinput/dateinput.component";
import { CalendarDatepickerComponent } from "../calendar/calendar-datepicker.component";
import { LayoutIconComponent } from "./layout-icon/layout-icon.component";
import { CropSettingsEditorComponent } from "./crop-settings-editor/crop-settings-editor.component";
import { NgxSmartModalComponent, NgxSmartModalModule } from "ngx-smart-modal";
import { ChooseSegmentComponent } from "../calendar/choose-segment/choose-segment.component";
import { MediaSegmentsComponent } from "../mediaEditor/media-segments/media-segments.component";
import { CollapsePanelComponent } from "./collapse-panel/collapse-panel.component";
import { CollapsibleComponent } from "./collapsible/collapsible.component";
import { BackToSchedulerComponent } from "./back-to-sceduler/back-to-scheduler.component";
import { ProgressStepper } from "./progress-stepper/progress-stepper.component";
import { MultiCheckboxSelectionComponent } from "./multi-checkbox-selection/multi-checkbox-selection";
import { VisualFilterComponent } from "./visual-filter/visual-filter.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { ReportWindowComponent } from "./report-window/report-window.component";
import { SuccessVIconComponent } from "./success-v-icon/success-v-icon.component";
import { AnimatedXButtonComponent } from "./close-btn/animated-x-btn/animated-x-btn.component";
import { AgGridEvrideoFooterComponent } from "./ag-grid-evrideo/ag-grid-evrideo-footer/ag-grid-evrideo-footer.component";
import { OutsideClickDirective } from "../../directives/outside-click.directive";
import { AgGridEvrideoSelectAllHeaderColumnComponent } from "./ag-grid-evrideo/ag-grid-evrideo-select-all-header-column/ag-grid-evrideo-select-all-header-column.component";
import { AgGridEvrideoCheckboxCellComponent } from "./ag-grid-evrideo/ag-grid-evrideo-checkbox-cell/ag-grid-evrideo-checkbox-cell.component";
import { ContextMenuModule } from "@perfectmemory/ngx-contextmenu";
import { AgGridEvrideoHeaderComponent } from "./ag-grid-evrideo/ag-grid-evrideo-header/ag-grid-evrideo-header.component";
import { AgGridEvrideoCheckedIconCellComponent } from "./ag-grid-evrideo/ag-grid-evrideo-checked-icon-cell/ag-grid-evrideo-checked-icon-cell.component";
import { AgGridEvrideoVideoNameCellComponent } from "./ag-grid-evrideo/ag-grid-evrideo-video-name-cell/ag-grid-evrideo-video-name-cell.component";
import { AgGridEvrideoProgressWheelComponent } from "./ag-grid-evrideo/ag-grid-evrideo-progress-wheel/ag-grid-evrideo-progress-wheel.component";
import { AgGridEvrideoSpinningWheelComponent } from "./ag-grid-evrideo/ag-grid-evrideo-spinning-wheel/ag-grid-evrideo-spinning-wheel.component";
import { TotSlidingToggleComponent } from "./tot-sliding-toggle/tot-sliding-toggle.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { IEvrideoDialogService } from "../../domain/common/i-evrideo-dialog-service";
import { EvrideoKeyboardShortcutsComponent } from "./evrideo-keyboard-shortcuts/evrideo-keyboard-shortcuts.component";
import { ICommonUtilInterface } from "../../domain/common/common-util.interface";
import { CommonUtils } from "../../infrastructure/common/CommonUtils";
import { MatIconModule } from "@angular/material/icon";
import { AgGridEvrideoStateIconComponent } from "./ag-grid-evrideo/ag-grid-evrideo-state-icon/ag-grid-evrideo-state-icon.component";
import { MatTabsModule } from "@angular/material/tabs";
import { TitleFilterPipe } from "../../pipes/title-filter.pipe";
import { DragPublicMediaComponent } from "../channel/channel-wizard/step1/drag-public-media.component";
import { VisibilityIconComponent } from "./visibility-icon/visibility-icon.component";
import { SoundIconComponent } from "./sound-icon/sound-icon.component";
import { NotAllowedIconComponent } from "./not-allowed-icon/not-allowed-icon.component";
import { HeadphonesIconComponent } from "./headphones-icon/headphones-icon.component";
import { SlideToConfirmComponent } from "./slide-to-confirm/slide-to-confirm.component";
@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    DatepickerModule,
    ColorPickerModule,
    InlineSVGModule.forRoot(),
    RouterModule,
    NgxSmartModalModule.forRoot(),
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    DragDropModule,
    MatSliderModule,
    ContextMenuModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatTabsModule,
  ],
  declarations: [
    SettingsButtonComponent,
    iDropdownComponent,
    ImageComponent,
    CopyButtonComponent,
    ButtonComponent,
    PreviewButtonComponent,
    DateTimePickerComponent,
    SeparateTimePickerComponent,
    TimeSliceComponent,
    CopyClipboardDirective,
    CheckboxComponent,
    XButtonComponent,
    TimeEditorComponent,
    HoverButtonComponent,
    TimeSliderComponent,
    DurationPipe,
    HoverButtonComponent,
    NumberInputComponent,
    RemoveButtonComponent,
    DropdownComponent,
    DropdownItemComponent,
    InputComponent,
    SimpleTextInputComponent,
    CloseButtonComponent,
    XButtonComponent,
    VideoContainerComponent,
    TimecodePipe,
    HumanizePipe,
    RemoveCommaPipe,
    HlsSrc,
    RadioCollectionComponent,
    TimeEditorComponent,
    DurationPipe,
    ColorPickerComponent,
    CalendarHeaderDropdownComponent,
    RectangleFComponent,
    LayerInputComponent,
    CalendarIconComponent,
    LinkComponent,
    DateinputComponent,
    CalendarDatepickerComponent,
    LayoutIconComponent,
    CropSettingsEditorComponent,
    MediaSegmentsComponent,
    ChooseSegmentComponent,
    CollapsePanelComponent,
    CollapsibleComponent,
    HeadPhoneComponent,
    WebRTCSrcDirective,
    LiveBroadcastLinkComponent,
    VolumeIconComponent,
    FullScreenIconComponent,
    GearIconComponent,
    SuccessVIconComponent,
    AnimatedXButtonComponent,
    AgGridEvrideoFooterComponent,
    OutsideClickDirective,
    BackToSchedulerComponent,
    ProgressStepper,
    MultiCheckboxSelectionComponent,
    VisualFilterComponent,
    ReportWindowComponent,
    AgGridEvrideoSelectAllHeaderColumnComponent,
    AgGridEvrideoCheckboxCellComponent,
    AgGridEvrideoHeaderComponent,
    AgGridEvrideoStateIconComponent,
    AgGridEvrideoCheckedIconCellComponent,
    AgGridEvrideoVideoNameCellComponent,
    AgGridEvrideoProgressWheelComponent,
    AgGridEvrideoSpinningWheelComponent,
    TotSlidingToggleComponent,
    EvrideoKeyboardShortcutsComponent,
    TitleFilterPipe,
    DragPublicMediaComponent,
    VisibilityIconComponent,
    SoundIconComponent,
    NotAllowedIconComponent,
    HeadphonesIconComponent,
    SlideToConfirmComponent,
  ],
  exports: [
    ImageComponent,
    PreviewButtonComponent,
    DateTimePickerComponent,
    CommonModule,
    DatepickerModule,
    SeparateTimePickerComponent,
    TimeSliceComponent,
    CopyButtonComponent,
    CopyClipboardDirective,
    CheckboxComponent,
    HoverButtonComponent,
    RemoveButtonComponent,
    NumberInputComponent,
    DropdownComponent,
    DropdownItemComponent,
    InputComponent,
    SimpleTextInputComponent,
    CloseButtonComponent,
    XButtonComponent,
    VideoContainerComponent,
    TimecodePipe,
    HlsSrc,
    RadioCollectionComponent,
    DurationPipe,
    TimeEditorComponent,
    CheckboxComponent,
    XButtonComponent,
    TimeEditorComponent,
    HoverButtonComponent,
    TimeSliderComponent,
    HumanizePipe,
    DurationPipe,
    RemoveCommaPipe,
    ColorPickerComponent,
    iDropdownComponent,
    CalendarHeaderDropdownComponent,
    RectangleFComponent,
    LayerInputComponent,
    CalendarIconComponent,
    LinkComponent,
    ButtonComponent,
    DateinputComponent,
    CalendarDatepickerComponent,
    LayoutIconComponent,
    CropSettingsEditorComponent,
    NgxSmartModalComponent,
    ChooseSegmentComponent,
    MediaSegmentsComponent,
    CollapsibleComponent,
    SettingsButtonComponent,
    HeadPhoneComponent,
    WebRTCSrcDirective,
    LiveBroadcastLinkComponent,
    VolumeIconComponent,
    FullScreenIconComponent,
    GearIconComponent,
    SuccessVIconComponent,
    AnimatedXButtonComponent,
    AgGridEvrideoFooterComponent,
    OutsideClickDirective,
    BackToSchedulerComponent,
    ProgressStepper,
    MultiCheckboxSelectionComponent,
    VisualFilterComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    ReportWindowComponent,
    AgGridEvrideoSelectAllHeaderColumnComponent,
    AgGridEvrideoCheckboxCellComponent,
    AgGridEvrideoHeaderComponent,
    AgGridEvrideoStateIconComponent,
    AgGridEvrideoCheckedIconCellComponent,
    AgGridEvrideoVideoNameCellComponent,
    AgGridEvrideoProgressWheelComponent,
    AgGridEvrideoSpinningWheelComponent,
    TotSlidingToggleComponent,
    MatSliderModule,
    EvrideoKeyboardShortcutsComponent,
    FormsModule,
    MatIconModule,
    MatTabsModule,
    TitleFilterPipe,
    DragPublicMediaComponent,
    VisibilityIconComponent,
    SoundIconComponent,
    NotAllowedIconComponent,
    HeadphonesIconComponent,
    SlideToConfirmComponent,
    DragDropModule,
  ],
  providers: [
    {
      provide: ICommonUtilInterface,
      useClass: CommonUtils,
    },
    {
      provide: IChannelBroadcastModeChecker,
      useClass: ChannelBroadcastModeChecker,
    },
    {
      provide: IEvrideoDialogService,
      useClass: EvrideoDialogService,
    },
  ],
})
export class EvrideoCommonModule {}
